export var FeatureFlagValue;
(function (FeatureFlagValue) {
    FeatureFlagValue["Control"] = "Control";
    FeatureFlagValue["A"] = "A";
    FeatureFlagValue["B"] = "B";
    FeatureFlagValue["C"] = "C";
    FeatureFlagValue["D"] = "D";
    FeatureFlagValue["E"] = "E";
    FeatureFlagValue["F"] = "F";
})(FeatureFlagValue || (FeatureFlagValue = {}));
export var FeatureFlagName;
(function (FeatureFlagName) {
    FeatureFlagName["Test"] = "Test";
    FeatureFlagName["TipSuggestionSmallAmounts"] = "TipSuggestionSmallAmounts";
    FeatureFlagName["TipSuggestionBigAmountsLargerThan400"] = "TipSuggestionBigAmountsLargerThan400";
    FeatureFlagName["TipSuggestionBigAmountsLargerThan1000"] = "TipSuggestionBigAmountsLargerThan1000";
    FeatureFlagName["TipSuggestionExperience"] = "TipSuggestionExperience";
    FeatureFlagName["IsFundraiserFormEditDisabled"] = "IsFundraiserFormEditDisabled";
    FeatureFlagName["LearnMoreOnTipMessage"] = "LearnMoreOnTipMessage";
    FeatureFlagName["IsPaymentByPadAllowed"] = "IsPaymentByPadAllowed";
    FeatureFlagName["IsBookADemoDisplayedWebflow"] = "IsBookADemoDisplayedWebflow";
    FeatureFlagName["IsNewMobileFormCreationFlow"] = "IsNewMobileFormCreationFlow";
    FeatureFlagName["IsAlgoliaForFormSearch"] = "IsAlgoliaForFormSearch";
    FeatureFlagName["IsZeffyUnderAttackFromCardTesting"] = "IsZeffyUnderAttackFromCardTesting";
    FeatureFlagName["IsCloudflareApiEnabled"] = "IsCloudflareApiEnabled";
    FeatureFlagName["IsAuctionRebiddingDisabled"] = "IsAuctionRebiddingDisabled";
    FeatureFlagName["FeaturePowerBalanceEnabled"] = "FeaturePowerBalanceEnabled";
    FeatureFlagName["PhishingDetectionThreshold"] = "PhishingDetectionThreshold";
    FeatureFlagName["CheckPhishingScoreWithOpenAI"] = "CheckPhishingScoreWithOpenAI";
    FeatureFlagName["ForceCheckPhishingScoreWitheOpenAI"] = "ForceCheckPhishingScoreWitheOpenAI";
    FeatureFlagName["ContactFilterV2"] = "contact-filter-v2";
    FeatureFlagName["EasierDonorRefund"] = "easier-donor-refund";
    FeatureFlagName["BlockEmailsOnRecipientSuspiciousActivity"] = "BlockEmailsOnRecipientSuspiciousActivity";
    FeatureFlagName["BlockOwnerEmailChangeFromForeignRegion"] = "BlockOwnerEmailChangeFromForeignRegion";
    FeatureFlagName["PostMailDiscounts"] = "PostMailDiscounts";
    FeatureFlagName["RecaptchaIsDeactivated"] = "RecaptchaIsDeactivated";
})(FeatureFlagName || (FeatureFlagName = {}));
